/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
import React, {
  useState, useCallback, useEffect, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { Combobox } from '@cgn/framework-ui-components/v2';
import useSceltaServizioDefaults from './useSceltaServizioDefaults';
import InfoModaleQuesito from '../../Shared/InfoModaleQuesito';
import { requestFocus } from '../../Shared/Utils';
import Riempimento from './Riempimento';
import AvvisoOperatoriNonDisponibili from './AvvisoOperatoriNonDisponibili';
import useServiziListaQuesiti from './useServiziListaQuesiti';
import AvvisoContenutoEsclusivoPianoNonAttivo from '../shared/AvvisoContenutoEsclusivoPianoNonAttivo';
import AvvisoContenutoEsclusivoPianoSospeso from '../shared/AvvisoContenutoEsclusivoPianoSospeso';
import AvvisoEvasionePrioritariaNonDisponibile from '../shared/AvvisoEvasionePrioritariaNonDisponibile';
import usePianoEccellenza, { StatoCategoriaPDE, StatoServizioPDE, StatoUfficioPDE } from '../../Shared/Profilo/usePianoEccellenza';
import { loadCategoriePerServizio } from '../../Api/nuovaPratica';

/**
*/
const SceltaServizio = ({
  baseUrl, areaSelezionata, ufficioSelezionato, selezioneBloccata, servizioBloccato, categoriaBloccata,
  servizio, servizioFisso, categoria, categoriaLabel, onChangeServizio, onChangeCategoria,
}) => {
  const servizioRef = useRef();
  const categoriaRef = useRef();
  const [servizioCorrente, setServizioCorrente] = useState(null);

  const eseguiUnaVoltaSeDefaultDefinito = useSceltaServizioDefaults(selezioneBloccata, servizioBloccato, categoriaBloccata, areaSelezionata, categoriaRef);

  const getServiziListaQuesiti = useServiziListaQuesiti(baseUrl, ufficioSelezionato);
  const categorieRef = useRef([]);

  const handleServizioSelected = useCallback((newServizio, validations, isOnInitializzation) => {
    setServizioCorrente(newServizio);
    if (isOnInitializzation) return;
    onChangeServizio && onChangeServizio(newServizio);
    // reset lo stato dipendente dal servizio
    categorieRef.current = [];
    categoriaRef.current.setValue(undefined);
    categoriaRef.current.setSearchValue('');
    categoriaRef.current.reloadItems();

    if (newServizio) {
      loadCategoriePerServizio(baseUrl, newServizio.IdServizio)
        .then((response) => {
          if (categorieRef.current) {
            categorieRef.current = response;
            categoriaRef.current?.setSearchValue('');
            categoriaRef.current?.reloadItems();
            eseguiUnaVoltaSeDefaultDefinito(
              'categoria',
              (idAliasCategoria) => assegnaCategoriaBloccata(idAliasCategoria, response, (value) => categoriaRef.current?.setValue(value)),
            );
          }
        });

      requestFocus(categoriaRef);
    }
  }, [baseUrl, eseguiUnaVoltaSeDefaultDefinito, onChangeServizio]);

  useEffect(() => {
    function setServizioValue(value) {
      if (servizioFisso) return;
      setTimeout(() => servizioRef.current?.setValue(value), 100);
    }

    getServiziListaQuesiti()
      .then((response) => {
        eseguiUnaVoltaSeDefaultDefinito('areaSelezionata', (area) => assegnaServizio(area, response, setServizioValue));
        eseguiUnaVoltaSeDefaultDefinito('servizio', (idServizio) => assegnaServizio(idServizio, response, setServizioValue));
      });
  }, [eseguiUnaVoltaSeDefaultDefinito, getServiziListaQuesiti, servizioFisso]);

  useEffect(() => {
    // eseguo per inizializzazione
    servizio && servizioRef.current && servizioRef.current.initializeValue(servizio);
    categoria && categoriaRef.current.initializeValue(categoria);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (servizioFisso) {
      handleServizioSelected(servizio, null, false);
    }
  }, [handleServizioSelected, servizio, servizioFisso]);

  const {
    statoUfficio,
    statoServizio,
    statoCategoria,
  } = usePianoEccellenza(ufficioSelezionato, servizioCorrente, categoria);

  return (
    <div className="helpdesk-frontend-step helpdesk-frontend-scelta-servizio">
      <div className="helpdesk-frontend-scelta-servizio__main">
        <div className="helpdesk-frontend-scelta-servizio__form">
          {!servizioFisso && (
            <div className="helpdesk-frontend-scelta-servizio__servizio">
              <Combobox
                ref={servizioRef}
                className="helpdesk-frontend-scelta-servizio__form-item helpdesk-frontend-scelta-servizio__servizi"
                title="Servizio*"
                itemKeyProperty="IdServizio"
                getSearchValueByItem={(item) => (item ? item.Descrizione : '')}
                onLoadItems={
                  (text) => getServiziListaQuesiti()
                    .then((servizi) => servizi
                      .filter((serv) => serv.Descrizione.toLowerCase().includes((text || '').toLowerCase())))
                }
                onSelected={handleServizioSelected}
                validations={[Combobox.Validations.required]}
                renderItem={servizioRender}
              />
              <AvvisoOperatoriNonDisponibili baseUrl={baseUrl} idServizio={servizioCorrente?.IdServizio} />
              {
                statoUfficio === StatoUfficioPDE.PDE_SOSPESO
                && statoServizio === StatoServizioPDE.SERVIZIO_PDE
                && statoCategoria !== StatoCategoriaPDE.ESCLUSIVA_ECCELLENZA
                && <AvvisoEvasionePrioritariaNonDisponibile />
              }
            </div>
          )}
          <div className="helpdesk-frontend-scelta-servizio__categoria">
            <Combobox
              ref={categoriaRef}
              className="helpdesk-frontend-scelta-servizio__form-item helpdesk-frontend-scelta-servizio__categorie"
              listClassName="helpdesk-frontend-scelta-servizio__categorie-select-list"
              title={categoriaLabel}
              listTop={!servizioFisso}
              getSearchValueByItem={(item) => (item ? item.Categoria : '')}
              itemKeyProperty="IdCategoria"
              onLoadItems={(text) => Promise.resolve(
                categorieRef.current
                  .filter((categ) => categ.IdCategoriaPadre === 0 && categ.Categoria.toLowerCase().includes((text || '').toLowerCase())),
              )}
              renderItem={categoriaRender}
              disabled={!servizio}
              onSelected={(cat) => {
                if (cat && !cat.argomenti) {
                  cat.argomenti = categorieRef.current.filter((c) => c.IdCategoriaPadre === cat.IdCategoria);
                }
                onChangeCategoria(cat);
              }}
            />
            {
              statoUfficio === StatoUfficioPDE.PDE_SOSPESO
              && statoCategoria === StatoCategoriaPDE.ESCLUSIVA_ECCELLENZA
              && <AvvisoContenutoEsclusivoPianoSospeso />
            }
            {
              statoUfficio === StatoUfficioPDE.PIANO_QUALITA
              && statoCategoria === StatoCategoriaPDE.ESCLUSIVA_ECCELLENZA
              && <AvvisoContenutoEsclusivoPianoNonAttivo />
            }
          </div>
        </div>
        <Riempimento
          statoUfficio={statoUfficio}
          statoServizio={statoServizio}
          statoCategoria={statoCategoria}
        />
      </div>
      <InfoModaleQuesito infoModaleQuesito={categoria && categoria.InfoEvasione} />
    </div>
  );
};

SceltaServizio.propTypes = {
  baseUrl: PropTypes.string,
  areaSelezionata: PropTypes.string,
  ufficioSelezionato: PropTypes.string,
  selezioneBloccata: PropTypes.bool,
  categoriaBloccata: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  servizioBloccato: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  onChangeServizio: PropTypes.func,
  servizio: PropTypes.shape({
    IdServizio: PropTypes.number,
  }),
  /**
   * Se il servizio è fissato, quello che devo scegliere è solo la categoria,
   */
  servizioFisso: PropTypes.bool,

  onChangeCategoria: PropTypes.func.isRequired,
  categoriaLabel: PropTypes.string,
  categoria: PropTypes.shape({
    IdCategoria: PropTypes.number,
    IdCategoriaPadre: PropTypes.number,
    InfoEvasione: PropTypes.string,
    EsclusivaEccellenza: PropTypes.bool,
    argomenti: PropTypes.arrayOf(PropTypes.shape({
      IdCategoria: PropTypes.number,
      IdCategoriaPadre: PropTypes.number,
    })),
  }),
};

SceltaServizio.defaultProps = {
  baseUrl: '',
  ufficioSelezionato: undefined,
  areaSelezionata: undefined,
  selezioneBloccata: undefined,
  categoriaBloccata: 0,
  servizioBloccato: 0,
  servizio: undefined,
  categoria: undefined,
  servizioFisso: false,
  categoriaLabel: 'Categoria*',
  onChangeServizio: undefined,
};

export default SceltaServizio;

function assegnaCategoriaBloccata(idAliasCategoria, response, onChangeCategoria) {
  let categoriaBloccata = [];
  if (typeof idAliasCategoria === 'number') {
    categoriaBloccata = response.filter((x) => x.IdCategoria === idAliasCategoria);
  } else {
    categoriaBloccata = response.filter((x) => x.Categoria === idAliasCategoria);
  }
  if (categoriaBloccata.length === 1) {
    onChangeCategoria(categoriaBloccata[0]);
  }
}

function assegnaServizio(idAliasServizio, servizi, setServizioValue) {
  let servizio;
  if (typeof idAliasServizio === 'number') {
    servizio = servizi.find((x) => x.IdServizio === idAliasServizio);
  } else {
    servizio = servizi.find((x) => x.Alias === idAliasServizio);
  }
  if (servizio) {
    setServizioValue(servizio);
  }
}

function servizioRender({ IdServizio, Descrizione }, searchValue) {
  return <Combobox.Item key={IdServizio} title={Descrizione} highlightedText={searchValue} />;
}

function categoriaRender({ IdCategoria, Categoria }, searchValue) {
  return <Combobox.Item key={IdCategoria} title={Categoria} highlightedText={searchValue} />;
}
